import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { useRoute } from "vue-router";

export const useModeStore = defineStore("mode", () => {
  const route = useRoute();
  
  // Mode is always determined by current route
  const mode = computed(() => {
    return route.path.startsWith("/user") ? "user" : "helper";
  });
  
  // Expansion state only matters for user mode, always start collapsed
  const isExpanded = ref(false);
  
  // Autoclose timer for user mode
  let autoCollapseTimer: NodeJS.Timeout | null = null;
  
  // Toggle expanded state - only works in user mode
  function toggleExpanded() {
    // In helper mode, switcher should always remain expanded
    if (mode.value === "helper") return;
    
    isExpanded.value = !isExpanded.value;
    
    // Clear any existing timer
    if (autoCollapseTimer) {
      clearTimeout(autoCollapseTimer);
      autoCollapseTimer = null;
    }
    
    // If we just expanded in user mode, start the auto-collapse timer
    if (isExpanded.value && mode.value === "user") {
      autoCollapseTimer = setTimeout(() => {
        isExpanded.value = false;
        autoCollapseTimer = null;
      }, 3000); // Auto collapse after 3 seconds
    }
  }
  
  // Function to forcibly collapse the mode switcher (for clock page)
  function forceCollapse() {
    if (mode.value === "user" && isExpanded.value) {
      isExpanded.value = false;
      if (autoCollapseTimer) {
        clearTimeout(autoCollapseTimer);
        autoCollapseTimer = null;
      }
    }
  }
  
  return {
    mode,
    isExpanded,
    toggleExpanded,
    forceCollapse,
  };
});
